import { Component, OnInit, Output, EventEmitter, Input  } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { IBaseCampaignDto, IKeyValuesPairOASDto } from '@Workspace/_generated/interfaces';
import { Subject } from 'rxjs';
import { CampaignController } from '@Workspace/_generated/services';
import { eInventoryTypeOAS } from '@Workspace/_generated/enums';

@Component({
    selector: 'key-value-pair-accordion',
    templateUrl: './key-value-pair-accordion.component.html',
    styleUrls: ['./key-value-pair-accordion.component.scss']
})
export class KeyValuePairAccordion implements OnInit {

    keyValuePairSectionId: any;
    keyValuePairPageTemplateId: any;
    keyValuePairSportId: any;
    header: string;
    keyValuePairsFriendlyValueSection: SelectItem[] = [];
    keyValuePairsFriendlyValuePageTemplate: SelectItem[] = [];
    keyValuePairsFriendlyValueSport: SelectItem[] = [];
    keyValuePairsFriendlyValue: SelectItem[] = [];
    keyValuesPairsOAS: IKeyValuesPairOASDto[] = [];
    enumInventoryTypeOAS = eInventoryTypeOAS;

    
    @Output('onSave') onSave: EventEmitter<any> = new EventEmitter<any>();
    @Input() baseCampaign: IBaseCampaignDto;
    @Input() disabled: boolean = false;

    constructor(
        public campaignController: CampaignController,
    ) { }

    ngOnInit() {
        this.campaignController.GetKeyValuesPairsOAS().subscribe(data => {
             this.keyValuesPairsOAS = data;
            if(this.baseCampaign.campaignInventoryItems[0].inventoryItemOAS.inventoryType == eInventoryTypeOAS.Page_Takeover_Premium)
            {
                this.keyValuePairsFriendlyValueSection = data.filter(x => x.definition == "Sport Section" && x.season == this.baseCampaign.campaignInventoryItems[0].inventoryItemOAS.season)
                .sort((a, b) => a.friendlyValues.localeCompare(b.friendlyValues))
                .map(x => { return { value: x.id, label: x.friendlyValues } });
                this.keyValuePairsFriendlyValueSection.unshift({ value: null, label: '-' });
            }
            else{
                this.keyValuePairsFriendlyValueSection = data.filter(x => x.definition == "Sport Section")
                .sort((a, b) => a.friendlyValues.localeCompare(b.friendlyValues))
                .map(x => { return { value: x.id, label: x.friendlyValues } });

                this.keyValuePairsFriendlyValuePageTemplate = data.filter(x => x.definition == "Page Template")
                 .sort((a, b) => a.friendlyValues.localeCompare(b.friendlyValues))
                .map(x => { return { value: x.id, label: x.friendlyValues } });
                
                this.keyValuePairsFriendlyValueSection.unshift({ value: null, label: '-' });
                this.keyValuePairsFriendlyValuePageTemplate.unshift({ value: null, label: '-' });
            }

            if(this.baseCampaign.campaignInventoryItems[0]?.inventoryItemOAS?.inventoryType == eInventoryTypeOAS.Sponsorship  || this.baseCampaign.campaignInventoryItems[0]?.inventoryItemOAS?.inventoryType == eInventoryTypeOAS.Banner_Ad || this.baseCampaign.campaignInventoryItems[0]?.inventoryItemOAS?.inventoryType == eInventoryTypeOAS.Website_Entitlement || this.baseCampaign.campaignInventoryItems[0]?.inventoryItemOAS?.inventoryType == eInventoryTypeOAS.Mobile){
                this.keyValuePairsFriendlyValueSport = data.filter(x => x.definition == "Sport Name")
                .sort((a, b) => a.friendlyValues.localeCompare(b.friendlyValues))
                .map(x => { return { value: x.id, label: x.friendlyValues } });
                this.keyValuePairsFriendlyValueSport.unshift({ value: null, label: '-' });
            }
        });

        this.loadData(
            this.baseCampaign.oasCustomTargetingJson?.keyValuesPairOASSectionId,
            this.baseCampaign.oasCustomTargetingJson?.keyValuesPairOASPageTamplateId,
            this.baseCampaign.oasCustomTargetingJson?.sportId,
            'OAS site',
        );
    }

    loadData(keyValueSection: any, keyValuePageTamplate: any, keyValuePairSportId: any, header: string) {
        this.header = header;
        this.keyValuePairSectionId = keyValueSection;
        this.keyValuePairPageTemplateId = keyValuePageTamplate;
        this.keyValuePairSportId = keyValuePairSportId;
    }
   
    save() {
        if(this.baseCampaign.campaignInventoryItems[0].inventoryItemOAS.inventoryType == eInventoryTypeOAS.Page_Takeover && 
            !!this.keyValuePairPageTemplateId && !!this.keyValuePairSectionId)
        {
            const dialogResult = {
                dialogType: 'keyValuePair',
                keyValuePairOASSection : this.keyValuesPairsOAS.find(x => x.id == this.keyValuePairSectionId),
                keyValuePairOASPageTemplate : this.keyValuesPairsOAS.find(x => x.id == this.keyValuePairPageTemplateId),
                keyValuePairOASSport : this.keyValuesPairsOAS.find(x => x.id == this.keyValuePairSportId),
            };
            this.onSave.emit(dialogResult); 
        }
        else if(this.baseCampaign.campaignInventoryItems[0].inventoryItemOAS.inventoryType == eInventoryTypeOAS.Page_Takeover_Premium && !!this.keyValuePairSectionId)
        {
            const dialogResult = {
                dialogType: 'keyValuePair',
                keyValuePairOASSection : this.keyValuesPairsOAS.find(x => x.id == this.keyValuePairSectionId),
                keyValuePairOASPageTemplate : this.keyValuesPairsOAS.find(x => x.id == this.keyValuePairPageTemplateId),
                keyValuePairOASSport : this.keyValuesPairsOAS.find(x => x.id == this.keyValuePairSportId),
            };
            this.onSave.emit(dialogResult);
        }
        else if((this.baseCampaign.campaignInventoryItems[0]?.inventoryItemOAS?.inventoryType == eInventoryTypeOAS.Sponsorship  || this.baseCampaign.campaignInventoryItems[0]?.inventoryItemOAS?.inventoryType == eInventoryTypeOAS.Banner_Ad  || this.baseCampaign.campaignInventoryItems[0]?.inventoryItemOAS?.inventoryType == eInventoryTypeOAS.Website_Entitlement || this.baseCampaign.campaignInventoryItems[0]?.inventoryItemOAS?.inventoryType == eInventoryTypeOAS.Mobile) && !!this.keyValuePairSportId){
             const dialogResult = {
                dialogType: 'keyValuePair',
                keyValuePairOASSection : this.keyValuesPairsOAS.find(x => x.id == this.keyValuePairSectionId),
                keyValuePairOASPageTemplate : this.keyValuesPairsOAS.find(x => x.id == this.keyValuePairPageTemplateId),
                keyValuePairOASSport : this.keyValuesPairsOAS.find(x => x.id == this.keyValuePairSportId),
            };
            this.onSave.emit(dialogResult);
        }
    }

}